import http from '@core/fetch'
import type { PayPayReqBody, PayPayResBodyData , PayPayStatusReqQuery, PayPayStatusResBodyData, PayFindOrderInfoReqQuery, PayFindOrderInfoResBodyData } from './types'

export default {
  /**
   * 订单支付
   * @param body
   * @returns
   */
  pay: (body: Partial<PayPayReqBody> ) => http.post<PayPayResBodyData>('/hms/piXiu/appApi/order/pay/pay', { body }),
  /**
   * 查询订单状态
   * @param body
   * @returns
   */
  check_pay: (body: Partial<PayPayStatusReqQuery>) => http.get<PayPayStatusResBodyData>('/hms/piXiu/appApi/order/pay/findPayStatusAndOrderStatus', { body }),
  /**
   * 查询订单信息
   * @param body
   * @returns
   */
   findOrderInfo: (body: Partial<PayFindOrderInfoReqQuery> )=>http<PayFindOrderInfoResBodyData>('/hms/piXiu/appApi/order/pay/findOrderInfo', { body, })
}
